import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class SeasonEquipStats extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            fromWeek: '',
            toWeek: '',
            fromSection: '',
            toSection: '',
            showClubs: false,
        });
    }

    fields = [];
    render() {
        return <div className="season-equip-stats reports-inner-box report-options">
            <table style={{maxWidth: '500px'}}>
                <tbody>
                    <tr>
                        <td><label htmlFor="fromWeek">Fra uge</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="fromWeek" id="fromWeek" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,2}"}]} value={this.state.fromWeek}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[0] = instance; }}
                        /></td>
                        <td><label htmlFor="toWeek">Til uge</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="toWeek" id="toWeek" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,2}"}]} value={this.state.toWeek}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[1] = instance; }}
                        /></td>
                    </tr>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                        <td><label htmlFor="fromSection">Fra sektion</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="fromSection" id="fromSection" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.fromSection}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[2] = instance; }}
                        /></td>
                        <td><label htmlFor="toSection">Til sektion</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="toSection" id="toSection" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.toSection}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[3] = instance; }}
                        /></td>
                    </tr> : null}
                </tbody>
            </table>
            <div className="options-separator"/>
            {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <div className="options-group">
                <input id="showClubs" name="showClubs" type="checkbox" checked={this.state.showClubs} onClick={e => this.setState({showClubs: !this.state.showClubs})}/> <label htmlFor="showClubs">Vis foreninger</label>
            </div>}
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        const options = {
            fromWeek: this.state.fromWeek === '' ? null : Number(this.state.fromWeek),
            toWeek: this.state.toWeek === '' ? null : Number(this.state.toWeek),
            fromSection: this.state.fromSection === '' ? null : this.state.fromSection,
            toSection: this.state.toSection === '' ? null : this.state.toSection,
            showClubs: this.state.showClubs,
        };

        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(SeasonEquipStats);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/SeasonEquipStats.js